<style scoped lang="less">
  p.thick {
    font-weight: bold;
    font-size: medium;
  };
</style>
<template>
  <Modal title="学员转移工单" v-model="visible" width="450">
    <Form ref="form" class="form" :label-width="90" label-position="left"
          :model="formData" :rules="fromRules"  >
      <Row>
        <i-col :span="20" :offset="1">
          <FormItem label="学生ID" prop="uid">
            <Input v-model="formData.uid" :readonly="true"></Input>
          </FormItem>
        </i-col>
      </Row>
      <Row>
        <i-col :span="20" :offset="1">
          <Form-item label="学生姓名" prop="nickname">
            <Input v-model="formData.nickname" :readonly="true"></Input>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :span="22" :offset="1" style="text-align: center">
          <p class="thick">确认转移学员{{formData.uid}}-{{formData.nickname}}至学导部门？</p>
        </i-col>
      </Row>

    </Form>
    <div slot="footer">
      <Button type="primary" size="large" :loading="loading" @click="handleSubmit">是</Button>
      <Button type="text" size="large" @click="onClose">否</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'changeDirectorModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        loading: false,
        nextHandler: [],
        formData: {
          uid: null,
          nickname: '',
        },
        fromRules: {
          uid: [
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
          ],
          nickname: [
            { type: 'string', required: true, message: '名称不能为空', trigger: 'blur' },
          ]
        },
      }
    },
    created () {
    },
    mounted () {
      this.getUserInfo()
    },
    computed: {
      visible: {
        get: function () {
          return this.value
        },
        set: function () {
          this.onClose()
        }
      }
    },
    methods: {
      getUserInfo () {
        let self = this
        if (!self.formData.uid) {
          return
        }
        self.$http.post('/user/queryById', {'uid': self.formData.uid}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          let user = res.data
          self.formData.nickname = user.nickname
        })
      },
      handleSubmit () {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }

          self.$http.post('/userTrack/changeDirectorRecord', self.formData).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
//              self.successCallback()
              self.onClose()
              self.onSuccess()
            }
          })
        })
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      }
    },
    watch: {
      value (val) {
        console.log(this.data)
        this.formData.uid = this.data.uid
        this.formData.nickname = this.data.nickName
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ChangeDirectorModal.vue?7e965027